import { useCallback, useEffect, useState } from "react";
import { useService } from "../../../../hooks";

export const useFormSlider = () => {
  const { fetchAll } = useService("Data", "subscription");
  const { getServices } = useService("Service");
  const [serviceSliderList, setserviceSliderList] = useState(null);
  const [subscriptionData, setsubscriptionData] = useState(null);

  const getSubscriptionData = useCallback(async () => {
    const result = await fetchAll();
    if (result.status) {
      setsubscriptionData(result.data);
    }
  }, [fetchAll]);

  const getServicesData = useCallback(async () => {
    const result = await getServices();
    if (result.status) {
      setserviceSliderList(result.data);
    }
  }, [getServices]);

  useEffect(() => {
    getServicesData();
    getSubscriptionData();
  }, [getServicesData, getSubscriptionData]);

  return {
    serviceSliderList,
    subscriptionData,
  };
};
